/**
 * File: index.jsx
 * Path: /src/index.jsx
 * Description: Entry point of the React application that renders the App component into the DOM.
 * Key Features: Sets up React Router and StrictMode.
 * Maintenance Notes: Rarely needs modification unless adding global providers.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/globals.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);